import { useState, useEffect, useCallback } from 'react';
const useContentTree = (target, selectors) => {
  const [contentTree, setContentTree] = useState([]);
  const getNodes = useCallback(parentTag => {
    const nodeList = parentTag.querySelectorAll(selectors.join(', '));
    const nodes = [];
    nodeList.forEach(nodeNode => {
      const {
        id,
        innerText,
        tagName
      } = nodeNode;
      nodes.push({
        id: `#${id}`,
        text: innerText,
        level: selectors.indexOf(tagName.toLowerCase())
      });
    });
    return nodes;
  }, [selectors]);
  const buildTree = useCallback(nodes => {
    // Track the nodes we've seen so far in the same level
    const currentSameLevelNodes = [];
    // Track nodes of the next level which will be children of the current node
    let nextLevelNodes = [];
    // Track the current node level
    let lastLevel = -1;

    // If the nodes are empty, return an empty tree
    if (nodes.length === 0) {
      return [];
    }
    const buildSubTree = () => {
      if (nextLevelNodes.length > 0) {
        currentSameLevelNodes[currentSameLevelNodes.length - 1].children.push(...buildTree(nextLevelNodes));
      }
    };
    nodes.forEach(node => {
      // If the node is of a greater level, we need to build the sub tree
      if (lastLevel !== -1 && lastLevel < node.level) {
        nextLevelNodes.push(node);
        return;
      }

      // build a subtree
      buildSubTree();

      // reset the next level nodes
      lastLevel = node.level;
      // add the current node to the current level nodes
      currentSameLevelNodes.push({
        id: node.id,
        text: node.text,
        children: []
      });
      // reset the next level nodes after building the subtree
      nextLevelNodes = [];
    });

    // build subtree
    buildSubTree();
    return currentSameLevelNodes;
  }, []);
  useEffect(() => {
    if (target.current) {
      const nodes = getNodes(target.current);
      const tree = buildTree(nodes);
      setContentTree(tree);
    }
  }, [target.current]);
  return contentTree;
};
export default useContentTree;